/**
 * What the automatic-invoice engine can issue in each pattern. Stored settings of every pattern
 * keep working; the settings only tell the admin which patterns produce nothing automatically.
 * - never: the pattern needs data the engine does not build (currency, contract, bill, flight,
 *   shipment) or is not supported (commodity exchange);
 * - notFromPos: issued from the form or the automatic Excel, never from POS transactions, which
 *   are invoice type 2 without an insurance policy id.
 */
export type AutomaticInvoiceTemplateLimit = {
  scope: 'never' | 'notFromPos'
  label: string
  note: string
}

const neverLabel = 'صدور خودکار ندارد'
const notFromPosLabel = 'از کارت‌خوان صادر نمی‌شود'

const limits: Record<number, AutomaticInvoiceTemplateLimit> = {
  2: {
    scope: 'never',
    label: neverLabel,
    note: 'صورتحساب خودکار در این الگو صادر نمی‌شود؛ اطلاعات ارزی آن ساخته نمی‌شود.',
  },
  4: {
    scope: 'never',
    label: neverLabel,
    note: 'صورتحساب خودکار در این الگو صادر نمی‌شود؛ شناسهٔ قرارداد لازم دارد.',
  },
  5: {
    scope: 'never',
    label: neverLabel,
    note: 'صورتحساب خودکار در این الگو صادر نمی‌شود؛ شناسهٔ قبض لازم دارد.',
  },
  6: {
    scope: 'never',
    label: neverLabel,
    note: 'صورتحساب خودکار در این الگو صادر نمی‌شود؛ اطلاعات پرواز لازم دارد.',
  },
  7: {
    scope: 'never',
    label: neverLabel,
    note: 'صورتحساب خودکار در این الگو صادر نمی‌شود؛ اطلاعات ارزی و گمرکی آن ساخته نمی‌شود.',
  },
  8: {
    scope: 'never',
    label: neverLabel,
    note: 'صورتحساب خودکار در این الگو صادر نمی‌شود؛ اطلاعات حمل لازم دارد.',
  },
  11: {
    scope: 'never',
    label: neverLabel,
    note: 'صورتحساب خودکار در الگوی بورس کالا صادر نمی‌شود.',
  },
  13: {
    scope: 'notFromPos',
    label: notFromPosLabel,
    note: 'فقط از فرم یا اکسل صورتحساب خودکار، همراه شناسهٔ یکتای بیمه‌نامه صادر می‌شود؛ از تراکنش کارت‌خوان صادر نمی‌شود.',
  },
  14: {
    scope: 'notFromPos',
    label: notFromPosLabel,
    note: 'فقط در نوع صورتحساب ۱ صادر می‌شود؛ تراکنش‌های کارت‌خوان نوع صورتحساب ۲ هستند.',
  },
}

export const getAutomaticInvoiceTemplateLimit = (templateId: number) => limits[templateId]
